import { gql } from '@apollo/client';

export const getCajasDisponibles = gql`
query cajasDisponiblesApi{
    cajasDisponibles(idSucCaja:$idSucCaja)  
    @rest(type: "cajasDisponiblesModel", path: "/gateway/cajasseguridad/cajas/getCofre/{args.idSucCaja}"){
       cofres
       sucursal
    }
}
`  